import React from "react";
import {
  Paper,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  lighten,
  useTheme,
} from "@mui/material";

const ScoreSummary = ({ data }) => {
  const theme = useTheme();
  const scoreItems = [
    {
      label: "Coding Intensity Adjuster",
      value: data.coding_intensity_adjuster,
    },
    { label: "Normalization Factor", value: data.normalization_factor },
    { label: "Demographic Score Raw", value: data.demographic_score_raw },
    { label: "Demographic Score", value: data.demographic_score },
    { label: "Disease Score Raw", value: data.disease_score_raw },
    { label: "Disease Score", value: data.disease_score },
    { label: "Total Score Raw", value: data.score_raw },
    { label: "Total Score", value: data.score },
  ];

  return (
    <Paper sx={{ p: 2, mt: 3, m: 2 }}>
      <Typography variant="h6" gutterBottom>
        RAF Score Summary
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow
            sx={{ backgroundColor: lighten(theme.palette.primary.main, 0.6) }}
          >
            <TableCell sx={{ fontWeight: 600 }}>Metric</TableCell>
            <TableCell sx={{ fontWeight: 600 }} align="right">
              Value
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {scoreItems.map((item, index) => (
            <TableRow key={index}>
              <TableCell>{item.label}</TableCell>
              <TableCell align="right">{item.value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default ScoreSummary;
